import { fromJS, List } from 'immutable';
import * as actionTypes from '../actions/metaAttachActionTypes';
import * as mainUIActionTypes from '../actions/mainUIActionTypes';
import {
  META_ATTACH_VIEW_NONE,
  META_ATTACH_VIEW_MASS_ADD,
  META_ATTACH_VIEW_POPULATE,
  META_ATTACH_VIEW_COPY,
  META_ATTACH_STATE_FETCHING_DATA,
  META_ATTACH_STATE_READY,
  META_ATTACH_STATE_IN_PROGRESS,
  META_ATTACH_STATE_SUCCESS,
  META_ATTACH_STATE_FAILURE,
  META_COPY_STATE_SUCCESS,
  META_COPY_STATE_FAILURE,
  META_COPY_STATE_IN_PROGRESS,
} from '../constants/metaAttachStates';

const initialState = fromJS({
  metadataToAttach: [],
  umoMetadata: [],
  umoID: '',
  umo: null,
  state: META_ATTACH_STATE_READY,
  viewType: META_ATTACH_VIEW_NONE,
  error: null,
});

const metaAttach = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.META_ATTACH_ADD:
      return state
        .set('metadataToAttach', new List(action.metadata))
        .set('state', META_ATTACH_STATE_READY)
        .set('viewType', META_ATTACH_VIEW_MASS_ADD)
        .set('umoID', '')
        .set('umo', null)
        .set('umoMetadata', [])
        .set('error', null);
    case actionTypes.META_ATTACH_POPULATE: {
      return state
        .set('state', META_ATTACH_STATE_READY)
        .set('viewType', META_ATTACH_VIEW_POPULATE)
        .set('umoID', action.umo.id)
        .set('umo', action.umo)
        .set('umoMetadata', [])
        .set('error', null);
    }
    case actionTypes.META_ATTACH_COPY:
      return state
        .set('state', META_ATTACH_STATE_READY)
        .set('viewType', META_ATTACH_VIEW_COPY)
        .set('umoID', action.umo.id)
        .set('umo', action.umo)
        .set('umoMetadata', [])
        .set('error', null);
    case actionTypes.META_ATTACH_CLEAR:
      return state
        .set('metadataToAttach', new List([]))
        .set('state', META_ATTACH_STATE_READY)
        .set('viewType', META_ATTACH_VIEW_NONE)
        .set('umoID', '')
        .set('umo', null)
        .set('umoMetadata', [])
        .set('error', null);
    case actionTypes.META_ATTACH_REQUEST:
      return state
        .set('state', META_ATTACH_STATE_IN_PROGRESS)
        .set('error', null);
    case actionTypes.META_ATTACH_SUCCESS:
      return state
        .set('state', META_ATTACH_STATE_SUCCESS)
        .set('error', null);
    case actionTypes.META_ATTACH_FAILURE:
      return state
        .set('state', META_ATTACH_STATE_FAILURE)
        .set('error', action.err);
    case actionTypes.META_COPY_REQUEST:
      return state
        .set('state', META_COPY_STATE_IN_PROGRESS)
        .set('error', null);
    case actionTypes.META_COPY_SUCCESS:
      return state
        .set('state', META_COPY_STATE_SUCCESS)
        .set('error', null);
    case actionTypes.META_COPY_FAILURE:
      return state
        .set('state', META_COPY_STATE_FAILURE)
        .set('error', action.err);
    case actionTypes.META_ATTACH_GET_UMO_METATAGS_REQUEST:
      return state
        .set('error', null)
        .set('state', META_ATTACH_STATE_FETCHING_DATA)
        .set('umoMetadata', []);
    case actionTypes.META_ATTACH_GET_UMO_METATAGS_SUCCESS:
      return state
        .set('error', null)
        .set('state', META_ATTACH_STATE_READY)
        .set('umoMetadata', action.metatags);
    case actionTypes.META_ATTACH_GET_UMO_METATAGS_FAILURE:
      return state
        .set('error', action.err)
        .set('state', META_ATTACH_STATE_FAILURE)
        .set('umoMetadata', []);
    case mainUIActionTypes.MAINUI_UMO_META_PANEL_TOGGLE:
      return state.set('viewType', META_ATTACH_VIEW_NONE);
    default:
      return state;
  }
};

export default metaAttach;
